export default {
	namespaced: true,

	state: {
		toUid: null,
		toName: null,

		pageName: null,
		pageType: null,
		
		chatCode: null,
		chatName: null,

		title: null,
		text: null,

		attachmentFileUrl: null,
		tag: [],

		quotedMessage: {}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
